/** 控制流条件表达式：与后端 WorkflowConditionEvaluator 操作符 wire 对齐 */

export const WORKFLOW_CONTROL_OPERATOR_VALUES = ['not_empty', 'equals', 'contains', 'is_true'] as const

export type WorkflowControlOperator = (typeof WORKFLOW_CONTROL_OPERATOR_VALUES)[number]

export const WORKFLOW_CONTROL_OPERATOR_LABELS: Record<WorkflowControlOperator, string> = {
  not_empty: '非空',
  equals: '等于',
  contains: '包含',
  is_true: '为真',
}

/** 下拉旁说明：贴合工作流语义（判断的是主输入连入的上一步产出） */
export const WORKFLOW_CONTROL_OPERATOR_HINTS: Record<WorkflowControlOperator, string> = {
  not_empty: '上一步产出有内容时成立',
  equals: '与比较值完全一致时成立',
  contains: '包含比较值中的文字时成立',
  is_true: '值为 true、1 或 yes 时成立',
}

export function workflowControlOperatorHint(
  operator: string,
  nodeType: 'condition.check' | 'loop.until',
): string {
  const key = operator as WorkflowControlOperator
  const base = WORKFLOW_CONTROL_OPERATOR_HINTS[key] ?? ''
  if (!base) return ''
  if (nodeType === 'loop.until') {
    return base.replace('成立', '从循环退出')
  }
  return `${base}，走「满足」分支`
}

export function workflowControlOperatorSummary(operator: string, expectValue?: string): string {
  const label = workflowControlOperatorLabel(operator)
  const expect = String(expectValue ?? '').trim()
  if (workflowControlOperatorNeedsExpectValue(operator) && expect) {
    return `${label}「${expect}」`
  }
  return label
}

export function workflowControlOperatorNeedsExpectValue(operator: string): boolean {
  return operator === 'equals' || operator === 'contains'
}

export function workflowControlOperatorLabel(operator: string): string {
  const key = operator as WorkflowControlOperator
  return WORKFLOW_CONTROL_OPERATOR_LABELS[key] ?? operator
}

/** 与后端 WorkflowGraphValidator / workflowGraphLint 共用的 lint code */
export const WORKFLOW_GRAPH_LINT_CODES = {
  GRAPH_EMPTY: 'GRAPH_EMPTY',
  START_MISSING: 'START_MISSING',
  END_UNREACHABLE: 'END_UNREACHABLE',
  NODE_ISOLATED: 'NODE_ISOLATED',
  NODE_NO_INCOMING: 'NODE_NO_INCOMING',
  CONDITION_FAIL_UNCONNECTED: 'CONDITION_FAIL_UNCONNECTED',
  CONDITION_PASS_UNCONNECTED: 'CONDITION_PASS_UNCONNECTED',
  CONTROL_SOURCE_FIELD_MISSING: 'CONTROL_SOURCE_FIELD_MISSING',
  CONTROL_EXPECT_VALUE_MISSING: 'CONTROL_EXPECT_VALUE_MISSING',
  LOOP_DONE_UNCONNECTED: 'LOOP_DONE_UNCONNECTED',
  LOOP_BODY_UNCONNECTED: 'LOOP_BODY_UNCONNECTED',
  LOOP_BODY_EMPTY: 'LOOP_BODY_EMPTY',
  LOOP_BODY_NOT_CLOSED: 'LOOP_BODY_NOT_CLOSED',
} as const
